import React from 'react'
import SbEditable from 'storyblok-react'
import Wave from 'src/utils/Wave'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import { Button as ButtonUI } from '@/components/ui/button'

const Hero = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div>
        <div className="relative bg-brightgreen">
          <div
            className={`relative max-w-6xl mx-auto px-6
                     ${blok.paddingBottom ? `pb-${blok.paddingBottom}` : 'pb-12'} ${blok.paddingTop ? `pt-${blok.paddingTop}` : ''}`}
          >
            <div
              className={`flex justify-center items-center gap-12
                             lg:${blok.paddingTop ? `pt-${parseInt(blok.paddingTop, 10) + 8}` : 'pt-40'} 
                             lg: ${blok.paddingBottom ? `pb-${parseInt(blok.paddingBottom, 10) + 8}` : 'pb-20'}
                             ${blok.paddingTop ? `pt-${blok.paddingTop}` : 'pt-32'}  
                             ${blok.paddingBottom ? `pb-${blok.paddingBottom}` : 'pb-12'}
                              ${blok.disable_two_column_layout ? 'flex-col' : 'lg:flex-row flex-col'}`}
            >
              <div
                className={`${blok.disable_two_column_layout ? 'w-full text-center' : 'lg:w-7/12 w-full'}`}
              >
                <Heading
                  size="h1"
                  className={`font-display text-darkblue ${blok.disable_two_column_layout ? 'lg:!text-[8.125rem] md:!text-6xl !text-5xl lg:tracking-[2px] tracking-[1px]' : 'md:!tracking-[-3.5px] tracking-[-2px]'}`}
                >
                  {blok.title}
                </Heading>
                <p
                  className={`mt-6 text-darkblue tracking-[-0.03em] ${blok.disable_two_column_layout ? 'lg:text-base text-sm max-w-2xl mx-auto' : 'lg:text-lg md:text-base text-sm'}`}
                >
                  {blok.description}
                </p>

                <ButtonUI
                  variant="secondary_blue"
                  to={blok.button_target?.cached_url}
                  before={blok.button_text}
                  className={`mt-8 mr-3 before:content-[attr(before)]`}
                >
                  {blok.button_text}
                </ButtonUI>
                <ButtonUI
                  variant="secondary"
                  to={blok.second_button_target?.cached_url}
                  before={blok.second_button_text}
                  className={`mt-8 before:content-[attr(before)]`}
                >
                  {blok.second_button_text}
                </ButtonUI>
              </div>
              <div
                className={`${blok.disable_two_column_layout ? 'md:w-full w-[80%] lg:order-first order-1' : 'lg:order-1 order-first lg:w-6/12 w-full'}`}
              >
                {/* FluidImage was causing width issues */}
                <img
                  className={`mx-auto`}
                  src={blok.image?.filename}
                  alt={`Hero - ${blok.image?.alt}`}
                />
              </div>
            </div>
          </div>
        </div>
        <Wave className="fill-brightgreen" />
      </div>
    </SbEditable>
  )
}

export default Hero
